import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { PopulationQueryKeys, usePopulationDataUploadApi, usePopulationsApi } from '@/api';

export const useBsimmControlsMappingUpload = () => {
  const { populationDataUploadApi } = usePopulationDataUploadApi();
  const queryClient = useQueryClient();

  const uploadFile = async (file: File) => {
    const formData = new FormData();
    formData.append('file', file);

    const response = await populationDataUploadApi.bsimmControlsMappingUploadApiAdminBsimmMappingByVersionUploadPost(
      file as unknown as string,
    );

    return response.data;
  };

  const mutation = useMutation({
    mutationFn: (file: File) => uploadFile(file),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [PopulationQueryKeys.bsimmControlsMappingUpload], // ??
      });
    },
    onError: (error: Error) => {
      if (error.name === 'AbortError') {
        console.warn('Upload cancelled');
        return;
      }
      console.error('Upload failed:', error);
    }
  });

  return {
    uploadFile: mutation.mutateAsync,
    isUploading: mutation.isPending,
    isError: mutation.isError,
    error: mutation.error,
  }
};

export const usePopulationDataUpload = () => {
  const { populationDataUploadApi } = usePopulationDataUploadApi();
  const queryClient = useQueryClient();

  const uploadFile = async (file: File) => {
    const formData = new FormData();
    formData.append('file', file);

    const response = await populationDataUploadApi.populationDataUploadApiAdminBsimmPopulationDataUploadPost(
      file as unknown as string,
    );

    return response.data;
  };

  const mutation = useMutation({
    mutationFn: (file: File) => uploadFile(file),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [PopulationQueryKeys.bsimmControlsMappingUpload], // ??
      });
    },
    onError: (error: Error) => {
      if (error.name === 'AbortError') {
        console.warn('Upload cancelled');
        return;
      }
      console.error('Upload failed:', error);
    }
  });

  return {
    uploadFile: mutation.mutateAsync,
    isUploading: mutation.isPending,
    isError: mutation.isError,
    error: mutation.error,
  }
};

export const useGetVerticals = () => {
  const { populationsApi } = usePopulationsApi();

  const { data, isLoading } = useQuery({
    queryKey: [PopulationQueryKeys.verticalsList],
    queryFn: async () => {
      const response = await populationsApi.getPopulationVerticalsApiPopulationsVerticalsGet();
      return response.data;
    },
    retry: 3,
  });

  return {
    verticalsList: data || [],
    isVerticalsListLoading: isLoading,
  };
};